module.exports = __webpack_public_path__ + "static/media/typing-effect.fe5a62c6.gif";